const classHotelSlider = 'hotels__slider',
    classRestaurantsSlider = 'restaurants__slider',
    classPackagesSlider = 'packages__slider',
    classMoviesSlider = 'movies__slider',
    classPagesSlider = 'pages__slider',
    classRoomsSlider = 'rooms__slider',
    classPostsSlider = 'posts__slider',
    classHighlightedPostsSlider = 'highlighted-posts__slider';

$('.'+classHotelSlider+', .'+classRestaurantsSlider+', .'+classPackagesSlider+', .'+classPagesSlider+', .'+classRoomsSlider+', .'+classPostsSlider+', .'+classHighlightedPostsSlider).slick({
    rows: 0,
    arrows: true,
    dots: true,
    prevArrow: '<a href="#" class="slick-control slick-control--prev" title="Vorige" rel="nofollow"><div class="slick-control__inner"><i class="far fa-angle-left"></i></div></a>',
    nextArrow: '<a href="#" class="slick-control slick-control--next" title="Volgende" rel="nofollow"><div class="slick-control__inner"><i class="far fa-angle-right"></i></div></a>',
    slidesToShow: 3,
    slidesToScroll: 1,
    swipeToSlide: true,
    infinite: false,
    speed: 500,
    lazyLoad: 'ondemand',
    customPaging: function (slick, index) {
        return '<button type="button" id="slick-dot-' + index + '" class="slick-dot" rel="nofollow"></button>';
    },
    responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 2
            }
        },{
            breakpoint: 768,
            settings: {
                slidesToShow: 1
            }
        }
    ]
});

// $('.'+classHighlightedPostsSlider).slick('slickSetOption', {
//     arrows: true,
//     prevArrow: '<a href="#" class="slick-control slick-control--prev" title="Vorige" data-gtm-event="Posts slider control: previous" rel="nofollow"><div class="slick-control__inner"><i class="far fa-angle-left"></i></div></a>',
//     nextArrow: '<a href="#" class="slick-control slick-control--next" title="Volgende" data-gtm-event="Posts slider control: next" rel="nofollow"><div class="slick-control__inner"><i class="far fa-angle-right"></i></div></a>',
// }, true);

$('.'+classMoviesSlider).slick({
    rows: 0,
    arrows: true,
    dots: false,
    prevArrow: '<a href="#" class="slick-control slick-control--prev" title="Vorige" data-gtm-event="Movie slider control: previous" rel="nofollow"><div class="slick-control__inner"><i class="far fa-angle-left"></i></div></a>',
    nextArrow: '<a href="#" class="slick-control slick-control--next" title="Volgende" data-gtm-event="Movie slider control: next" rel="nofollow"><div class="slick-control__inner"><i class="far fa-angle-right"></i></div></a>',
    slidesToShow: 5,
    slidesToScroll: 1,
    swipeToSlide: true,
    infinite: false,
    speed: 500,
    lazyLoad: 'ondemand',
    customPaging: function (slick, index) {
        return '<button id="slick-dot-' + index + '" class="slick-dot" rel="nofollow"></button>';
    },
    responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 4
            }
        },{
            breakpoint: 992,
            settings: {
                slidesToShow: 3
            }
        },{
            breakpoint: 580,
            settings: {
                dots: true,
                centerMode: true,
                infinite: true,
                slidesToShow: 1,
                centerPadding: '20%',
            }
        }
    ]
});

// moving sliders when item that is not active is clicked
$('.'+classHotelSlider+', .'+classRestaurantsSlider+', .'+classPackagesSlider+', .'+classPagesSlider+', .'+classRoomsSlider+', .'+classPostsSlider+', .'+classHighlightedPostsSlider+', .'+classMoviesSlider).on( 'click', '.slick-slide', function(e) {
    if( !$(this).hasClass('slick-active') ) {
        e.preventDefault();

        let $slider = $(this).closest('.slick-slider');

        // check if slide is before or after active slides
        if( $(this).prevAll('.slick-active').length ) {
            // console.log('element comes after active');
            $slider.slick('slickNext');
        } else {
            // console.log('element comes before active');
            $slider.slick('slickPrev');
        }
    }
});


const classGallerySlider = 'gallery__slider',
    classGalleryThumbActive = 'thumb--active';

$('.gallery:not(.gallery--alt) .'+classGallerySlider).on('init afterChange', function() {
    // update active thumb
    let $wrapper = $(this).closest('.gallery'),
        slideIndex = $wrapper.find('.'+ classGallerySlider +' .slick-current').data('slide-index');

    $wrapper.find('.gallery__thumbs [data-slide-index="'+ slideIndex +'"]').addClass(classGalleryThumbActive).siblings().removeClass(classGalleryThumbActive);
}).slick({
    rows: 0,
    arrows: true,
    dots: false,
    prevArrow: '<a href="#" class="slick-control slick-control--prev" title="Vorige" data-gtm-event="Gallery slider control: previous" rel="nofollow"><div class="slick-control__inner"><i class="far fa-angle-left"></i></div></a>',
    nextArrow: '<a href="#" class="slick-control slick-control--next" title="Volgende" data-gtm-event="Gallery slider control: next" rel="nofollow"><div class="slick-control__inner"><i class="far fa-angle-right"></i></div></a>',
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    infinite: false,
    speed: 500,
    adaptiveHeight: true,
    lazyLoad: 'ondemand'
});

$('.gallery__thumbs .thumb').on('click', function() {
    // update active class and move slider
    let slideIndex = $(this).data('slide-index');

    $(this).addClass(classGalleryThumbActive).siblings().removeClass(classGalleryThumbActive);
    $(this).closest('.gallery').find('.'+ classGallerySlider).slick('slickGoTo', (slideIndex-1));
});


$('.gallery.gallery--alt .'+classGallerySlider).slick({
    rows: 0,
    arrows: true,
    dots: true,
    prevArrow: '<a href="#" class="slick-control slick-control--prev" title="Vorige" data-gtm-event="Gallery slider control: previous" rel="nofollow"><div class="slick-control__inner"><i class="far fa-angle-left"></i></div></a>',
    nextArrow: '<a href="#" class="slick-control slick-control--next" title="Volgende" data-gtm-event="Gallery slider control: next" rel="nofollow"><div class="slick-control__inner"><i class="far fa-angle-right"></i></div></a>',
    slidesToShow: 5,
    slidesToScroll: 1,
    swipeToSlide: true,
    infinite: true,
    speed: 500,
    // adaptiveHeight: true,
    centermode: true,
    centerPadding: '50px',
    lazyLoad: 'ondemand',
    customPaging: function (slick, index) {
        return '<button id="slick-dot-' + index + '" class="slick-dot" rel="nofollow"></button>';
    },
    responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 3,
            }
        },{
            breakpoint: 580,
            settings: {
                slidesToShow: 1,
            }
        },
    ]
});


$('.cinema-agenda__dates-slider').slick({
    rows: 0,
    arrows: true,
    dots: false,
    prevArrow: '<a href="#" class="slick-control slick-control--prev" title="Vorige" data-gtm-event="Cinema dates slider control: previous" rel="nofollow"><div class="slick-control__inner"><i class="far fa-angle-left"></i></div></a>',
    nextArrow: '<a href="#" class="slick-control slick-control--next" title="Volgende" data-gtm-event="Cinema dates slider control: next" rel="nofollow"><div class="slick-control__inner"><i class="far fa-angle-right"></i></div></a>',
    slidesToShow: 7,
    slidesToScroll: 7,
    infinite: false,
    speed: 500,
    responsive: [
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 5,
            }
        },{
            breakpoint: 580,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
            }
        },{
            breakpoint: 400,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
            }
        },
    ]
});  

$('.notifications__slider').slick({
    rows: 0,
    arrows: true,
    dots: false,
    prevArrow: '<a href="#" class="slick-control slick-control--prev" title="Vorige" data-gtm-event="Notifications slider control: previous" rel="nofollow"><i class="far fa-angle-left"></i></a>',
    nextArrow: '<a href="#" class="slick-control slick-control--next" title="Volgende" data-gtm-event="Notifications slider control: next" rel="nofollow"><i class="far fa-angle-right"></i></a>',
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    infinite: false,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 4000,
    adaptiveHeight: true,
});


$('.hotels .hotel__gallery, .restaurants .restaurant__gallery, .rooms .room__gallery, .packages-wide .package__gallery').slick({
    rows: 0,
    arrows: true,
    dots: false,
    prevArrow: '<a href="#" class="slick-control slick-control--prev" title="Vorige" data-gtm-event="Tile gallery control: previous" rel="nofollow"><i class="far fa-angle-left"></i></a>',
    nextArrow: '<a href="#" class="slick-control slick-control--next" title="Volgende" data-gtm-event="Tile gallery control: next" rel="nofollow"><i class="far fa-angle-right"></i></a>',
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    infinite: false,
    speed: 500
});


$('.event__agenda__slider').slick({
    rows: 0,
    arrows: true,
    dots: false,
    prevArrow: '<a href="#" class="slick-control slick-control--prev" title="Vorige" data-gtm-event="Tile gallery control: previous" rel="nofollow"><i class="far fa-angle-left"></i></a>',
    nextArrow: '<a href="#" class="slick-control slick-control--next" title="Volgende" data-gtm-event="Tile gallery control: next" rel="nofollow"><i class="far fa-angle-right"></i></a>',
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    infinite: false,
    speed: 500
});